<div class="flex flex-col flex-grow">
  <router-outlet></router-outlet>
</div>

